export default {
  headerFont: "'Rubik', sans-serif",
  headerSize: 42,
  smallHeaderSize: 20,
  footerHeaderSize: 18,

  linkFont: '"Rubik", sans-serif',
  paragraphFont: '"Rubik", sans-serif',
  weights: {
    light: 300,
    medium: 400,
    bold: 500,
  },
};



// WEBPACK FOOTER //
// ./src/constants/typography.js